// ONBOARDING: This is a general functionality which we might want to use in future though it is currently not in use

// biome-ignore lint/style/noEnum: TODO: review this suppression
export enum Tips {
    USAGE_TAB = 'USAGE_TAB',
    RENEW_CONTRACTS = 'RENEW_CONTRACTS',
    CONTRACTS_PAGE_TOUR = 'CONTRACTS_PAGE_TOUR',
}
